import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  open() {
    window.dispatchEvent(new CustomEvent("link-in-bio-picker:reset"));
    this.element.querySelector("dialog")?.showModal();
  }
}
